import React from 'react';

import './CorrectWord.css'
const CorrectWord = (props) => {
  const { word } = props;
  const className = `story-correct-word ${word.length > 10 ? 'long' : ''}`;
  return <div className={className}> {word}</div>
}

export default CorrectWord